import { controls } from "../../controls";

const ms103 = {
    label: "Customer KYC Update",
    pageLabel: "Customer KYC Update",
    starting: true,
    url: "ms103",
    formActions: { edit: { allow: true }},
    pageType: "history",
  
    form:[
        ...controls.displayText({label: "Customer Number",width:"col-sm-2"}),
        ...controls.customerNumber({width:"col-sm-2" }),
        ...controls.showData({width:"col-sm-2",data:"customer_number_display"}),

        ...controls.displayText({ tab: "filter", label: "Customer Type", width: "col-sm-2" }),
        ...controls.CustomerType({ tab: "filter", width: "col-sm-2" }),

        ...controls.displayText({width:"col-sm-2"}),
        ...controls.displayText({label: "PAN",width:"col-sm-2"}),
        ...controls.panNumber({}),

        ...controls.displayText({width:"col-sm-2"}),
        ...controls.displayText({label: "AAdharUID",width:"col-sm-2"}),
        ...controls.aadharNumber({width:"col-sm-2"}),

        ...controls.displayText({width:"col-sm-2"}),
        ...controls.displayText({label: "POA",width:"col-sm-2"}),
        ...controls.POA({width:"col-sm-2"}),
        ...controls.showData({data: "proof_of_address_display", width:"col-sm-2"}),
        ...controls.displayText({label: "POI",width:"col-sm-2"}),
        ...controls.POI({width:"col-sm-2"}),
        ...controls.showData({data: "proof_of_identity_display", width:"col-sm-2"}),
        ...controls.displayText({label: "DOB",width:"col-sm-2"}),
        ...controls.datePicker({name:"dob",width:"col-sm-2"}),
        ...controls.displayText({width:"col-sm-2"}),
        ...controls.displayText({label: "Register Mobile No",width:"col-sm-2"}),
        ...controls.mobileNumber({name:"mobile_no",width:"col-sm-2"})
        ]
    }
export default ms103;